module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/222-niger-77b158e6c35b91c506eb8ed4e4c40324.svg";